const onClick = `function onClick(pubSub, namespace) {
  // write your code here
}`;

const onLoad = `function onLoad(pubSub) {
  // write your code here
}`;

const sampleCode = {
  onClick,
  onLoad,
};

export default sampleCode;
